import { render } from "./SubscriptionLoader.vue?vue&type=template&id=4ae1c810&scoped=true&ts=true"
import script from "./SubscriptionLoader.vue?vue&type=script&lang=ts"
export * from "./SubscriptionLoader.vue?vue&type=script&lang=ts"

import "./SubscriptionLoader.vue?vue&type=style&index=0&id=4ae1c810&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae1c810"]])

export default __exports__